function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useEffect, useRef } from "react";
import { Manager, Reference, Popper } from "react-popper";
import ReactDOM from "react-dom";
import styled from "styled-components";
import { GridColumn, P, GridRow } from "../";
export const TertiaryMenu = ({
  placement = "bottom-end",
  offset = "0, 4",
  items,
  onSelect,
  header,
  trigger,
  open,
  ...props
}) => {
  const [id] = useState(Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));
  const [isOpen, setOpen] = useState(false);
  const menuRef = useRef();
  const portal = useRef();
  let internalOpen;

  if (open === undefined) {
    internalOpen = isOpen;
  } else {
    internalOpen = open;
  }

  const handleClick = () => {
    setOpen(!isOpen);
  };

  const handleClickOut = e => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setOpen(false);
    }
  };

  const handleRef = (ref, cb) => {
    menuRef.current = ref;
    cb(ref);
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("click", handleClickOut);
      return () => {
        document.removeEventListener("click", handleClickOut);
      };
    }
  }, [isOpen]);
  useEffect(() => {
    const target = document.createElement("div");
    target.id = `portal${id}`;
    document.body.appendChild(target);
    portal.current = document.getElementById(`portal${id}`);
    return () => {
      document.getElementById(`portal${id}`).remove();
    };
  }, []);

  const handleSelect = value => {
    onSelect(value);
    setOpen(false);
  };

  return React.createElement(Manager, null, React.createElement(Reference, null, props => trigger({
    onClick: handleClick,
    ...props
  })), React.createElement(Popper, _extends({
    modifiers: {
      offset: {
        offset
      }
    },
    placement: placement
  }, props), ({
    ref,
    style,
    placement
  }) => internalOpen && portal.current ? ReactDOM.createPortal(React.createElement(MenuContainer, {
    ref: res => handleRef(res, ref),
    style: style,
    "data-placement": placement,
    isOpen: isOpen
  }, !!header && React.createElement(Header, null, header), !!items && items.map(({
    key,
    icon,
    label
  }) => {
    return React.createElement(MenuItem, {
      yCenter: true,
      key: key,
      thisKey: key,
      onClick: () => handleSelect(key)
    }, !!icon && icon, React.createElement(P, null, label));
  })), portal.current) : null));
};
const Header = styled(GridColumn)`
  border-bottom: 1px solid ${props => props.theme.colors.borderLight};
`;
const MenuItem = styled(GridRow)`
  background-color: #ffffff;
  border-bottom: 1px solid ${props => props.theme.colors.borderLight};
  cursor: pointer;
  height: 40px;
  padding: 0 12px;
  svg path {
    fill: ${props => props.theme.colors.disabledText};
  }
  ${P} {
    margin-left: 8px;
  }
  &:hover {
    background-color: ${props => props.thisKey !== "remove" ? "#f5f5f5" : props.theme.palette.red.lightest};
  }
`;
const MenuContainer = styled.div`
  background-color: #ffffff;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.32);
  display: flex;
  flex-direction: column;
  width: 288px;
  z-index: 200;
`;